export default __webpack_public_path__ + "media/gs_upgrade_email/spacer-f02ded29.gif";